import { useAuth0 } from '@auth0/auth0-react';
import React, { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SQLMorphRouting from './scripts/SQLMorphRouting';
import { SqlMorphContext, useSqlMorphReducer } from './scripts/app/reducer';
import Box from '@mui/material/Box';
import { HeaderNavItem, HeaderTabs } from 'Common/common-ui';
import CreateIcon from '@mui/icons-material/Create';
import * as SqlPaths from 'Sqlmorph/scripts/constants/paths';
import HelpIcon from '@mui/icons-material/Help';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import NotesIcon from '@mui/icons-material/Notes';
import PageHeader from 'Common/components/PageHeader';
import * as Paths from '@toolkit/router/paths';

const ABOUT_PATH = `${Paths.SqlTranslation}/${SqlPaths.about}`;
const navOptions: HeaderNavItem[] = [
  {
    icon: CreateIcon,
    title: 'Translate',
    to: `${Paths.SqlTranslation}/${SqlPaths.translate}`,
  },
  {
    icon: HelpIcon,
    title: 'Supported Statements',
    to: `${Paths.SqlTranslation}/${SqlPaths.supportStatements}`,
  },
  {
    icon: NotesIcon,
    title: 'Settings',
    to: `${Paths.SqlTranslation}/${SqlPaths.settings}`,
  },
  {
    icon: WebAssetIcon,
    title: 'Demo',
    to: `${Paths.SqlTranslation}/${SqlPaths.demoQueries}`,
  },
  {
    icon: NotesIcon,
    title: 'About',
    to: ABOUT_PATH,
  },
];

const SQLMorph: React.FC = () => {
  const [state, dispatch] = useSqlMorphReducer();
  const navigate = useNavigate();
  const location = useLocation();
  const auth0 = useAuth0();

  useEffect(() => {
    if (!auth0.isAuthenticated && location.pathname === Paths.SqlTranslation) {
      navigate(ABOUT_PATH);
    }
  }, [auth0, location, navigate]);

  function selectHeader(): ReactNode {
    if (location.pathname === ABOUT_PATH) {
      return (
        <PageHeader
          header="SQL Translation - SQLMorph"
          subHeader="Translate SQL Instantly"
          description="Instantly translate SQL from one language to another, eliminating a usually time-consuming, error-prone, and highly manual process."
        />
      );
    } else {
      return <PageHeader header="SQL Translation - SQLMorph" height={'8em'} />;
    }
  }

  return (
    <SqlMorphContext.Provider value={{ state, dispatch }}>
      <Box
        id="sql-app-container"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        {selectHeader()}
        <HeaderTabs navOptions={navOptions} />
        <SQLMorphRouting />
      </Box>
    </SqlMorphContext.Provider>
  );
};

export default SQLMorph;
